<template>
    <el-dropdown trigger="click" @command="changeLang">
        <span class="el-dropdown-link flex-level cpointer">
            <img :src="`/ressources/public/img/flags/lang/${currentLang.id}.png`" class="pr-2" />
            <span>{{ currentLang.label }}</span>
            <i class="icon-chevron-bottom ml-3 gray-60"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item 
                class="flex-level" 
                v-for="(lang, langKey) in languages" 
                :key="langKey"
                :command="lang.id">
                <img :src="`/ressources/public/img/flags/lang/${lang.id}.png`" class="pr-2" />
                <span>{{ lang.label }}</span>
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
    import { createNamespacedHelpers } from 'vuex';
    const { mapState } = createNamespacedHelpers('system');

    export default {
        props: {
            value: {
                type: String,
                required: true
            },
            availableLanguages: {
                type: Array,
                required: false,
                default: () => []
            }
        },
        computed: {
            ...mapState({
                allLanguages: 'availableLanguages'
            }),
            languages(){
                return this.availableLanguages.length > 0 ? this.allLanguages.filter(language => this.availableLanguages.includes(language.id)) : this.allLanguages
            },
            currentLang(){
                return this.languages.find(lang => lang.locale == this.value)
            }
        },
        methods: {
            changeLang(lang){
                LocalizationHelpers.changeLanguage(lang)
            }
        }
    }
</script>